import React from "react";
import { cleanDate } from "../../../../util/app";

const WaterlowList = ({ items = [], onConfirm, onView }) => {
    const tHeads = [
        { title: "SN", width: "5%", className: "text-center" },
        { title: "Sex", width: "10%", className: "text-left" },
        { title: "Age Range", width: "15%", className: "text-center" },
        {
            title: "BMI Range",
            width: "15%",
            className: "text-center",
        },

        {
            title: "continence",
            width: "20%",
            className: "text-left",
        },
        {
            title: "Date & Time",
            width: "15%",
            className: "text-left",
        },
        {
            title: "Status",
            width: "10%",
            className: "text-center",
        },
        {
            title: "Actions",
            width: "10%",
            className: "text-center",
        },
    ];

    if (items.length)
        return (
            <>
                <table className="table table-bordered">
                    <thead>
                        {tHeads.map((item) => (
                            <th style={{ width: item.width }} className={item.className} key={item.title}>
                                {item.title}
                            </th>
                        ))}
                    </thead>
                    <tbody>
                        {items.map((item, idx) => (
                            <tr key={item.id}>
                                <td className="text-center">
                                    <strong>{idx + 1}</strong>
                                </td>
                                <td>{item.sex}</td>
                                <td className="text-center">{item.age}</td>
                                <td className="text-center"> {item.bmiRange}</td>

                                <td>{item.continence}</td>

                                <td>{cleanDate(item.created_at)}</td>
                                <td>{item.confirm.status ? <span className="badge badge-success">Confirmed</span> : <span className="badge badge-danger">UnConfirmed</span>}</td>
                                <td className="text-center">
                                    <button onClick={() => onView(item)} title="View" className="mdl-button mdl-button--icon mdl-button--colored btn-default">
                                        <i className="material-icons text-primary">arrow_right_alt</i>
                                    </button>
                                    {!item.confirm.status && (
                                        <button onClick={() => onConfirm(item)} title="Confirm" className="mdl-button mdl-button--icon mdl-button--colored btn-default ml-2">
                                            <i className="material-icons text-success">check_circle</i>
                                        </button>
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </>
        );
    return (
        <div className="row fade-in">
            <div className="col-12 pt-5 mt-5 text-center">
                <h3 className="text-danger">No Waterlow Pressure Ulcer Prevention!</h3>
            </div>
        </div>
    );
};
export default WaterlowList;
